import * as React from 'react';

import AlertBadge16 from './AlertBadge16';

export const alertBadge16 = () => <AlertBadge16 />;

export default {
    title: 'Icon/Fill/AlertBadge16',
    component: AlertBadge16,
    parameters: {
        notes: "`import AlertBadge16 from 'box-ui-elements/es/icon/fill/AlertBadge16';`",
    },
};
